import { render } from "./DeliveryNotesView.vue?vue&type=template&id=57d34154&scoped=true"
import script from "./DeliveryNotesView.vue?vue&type=script&lang=js"
export * from "./DeliveryNotesView.vue?vue&type=script&lang=js"

import "./DeliveryNotesView.vue?vue&type=style&index=0&id=57d34154&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57d34154"]])

export default __exports__